import { alpha, Button, Stack, Typography, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { FC, ReactNode } from "react";

type Props = {
	icon: ReactNode;
	accent: string;
	label: string;
	subtitle: string;
	onClick: () => void;
};

export const WhatIfOptionRow: FC<Props> = ({
	icon,
	accent,
	label,
	subtitle,
	onClick,
}) => {
	const theme = useTheme();

	return (
		<Button
			variant="deprecatedListRow"
			disableRipple
			onClick={onClick}
			sx={{
				bgcolor: theme.palette.surface.muted,
				borderRadius: theme.radii.lg,
				px: 1.2,
				py: 1,
				gap: 1,
			}}
		>
			<Stack
				alignItems="center"
				justifyContent="center"
				flexShrink={0}
				bgcolor={alpha(accent, 0.12)}
				borderRadius={theme.radii.md}
				width={28}
				height={28}
			>
				{icon}
			</Stack>
			<Stack flex={1} minWidth={0} alignItems="flex-start">
				<Typography variant="caption" fontWeight={500}>
					{label}
				</Typography>
				<Typography variant="caption" color={theme.palette.grey[600]} tabular>
					{subtitle}
				</Typography>
			</Stack>
			<ChevronRight
				size={theme.iconSize.sm}
				color={theme.palette.grey[400]}
				style={{ flexShrink: 0 }}
			/>
		</Button>
	);
};
